<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-body no-padder loaderPosition">
        <div
          id="pick-cover-image"
          ref="coverImageBox"
          class="bg-dark lter cover-body covered"
          style="cursor: pointer;"
        ></div>
        <div v-if="!isCoverImageUrl" class="preloader"></div>
        <crop-image-cropper
          @completed="handleCoverImageCompleted"
          @error="handlerError"
          trigger="#pick-cover-image"
          upload-form-name="cover_image"
          :upload-url="uploadCoverImageUrl"
          :upload-headers="headersUrl"
        />
        <!-- TTILE -->
        <div class="cover-footer b-t b-info covered">
          <div class="panel-body" style="margin-left: 150px;">
            <span class="pull-left m-r-sm m-t-xs">
              <i class="i-2x fa fa-building-o text-info-lt"></i>
            </span>
            <span class="clear">
              <span class="h4 font-bold stage-li-no m-t-xs">{{profile.name}}</span>
              <small class="stage-li-desc block">
                <i class="fa fa-map-marker icon"></i>
                <span v-if="profile.city">{{ profile.city }}</span>
                <span class="text-u-c">{{ getCountryName(profile.country_id) }}</span>
              </small>
            </span>
          </div>
        </div>

        <!-- IMAGE -->
        <div class="cover-footer-img">
          <div
            class="text-center b b-white bg-white inline box-shadow"
            style="width: 128px; height: 128px;"
          >
            <div ref="logoBox" id="pick-avatar"></div>
            <div v-if="!isImageUrl" class="preloader"></div>
            <avatar-cropper
              @completed="handleCompleted"
              @error="handlerError"
              trigger="#pick-avatar"
              upload-form-name="logo"
              :upload-url="uploadUrl"
              :upload-headers="headersUrl"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="panel panel-default">
      <header class="panel-heading">
        <div class="row no-padder">
          <div class="col-md-6"></div>
          <div class="col-md-6">
            <div class="doc-buttons pull-right">
              <button
                type="submit"
                id="_profile_btn_submit"
                class="btn btn-s-xs btn-dark m-b-sm"
                @click="handleSubmit"
              >Submit</button>
              <button
                type="submit"
                id="_profile_btn_cancel"
                class="btn btn-s-xs btn-default m-b-sm"
                @click="handleCancel"
              >Cancel</button>
            </div>
          </div>
        </div>
      </header>
      <div class="hbox stretch">
        <!-- TABS -->
        <aside class="aside-xs b-r">
          <ul class="nav nav-list nav-right">
            <li class="active">
              <a data-toggle="tab" href="#org-details">
                Organization details
                <i class="fa"></i>
              </a>
            </li>
            <li class>
              <a data-toggle="tab" href="#org-productsandservices">
                Products and services
                <i class="fa"></i>
              </a>
            </li>
            <li class>
              <a data-toggle="tab" href="#org-history">
                History and milestones
                <i class="fa"></i>
              </a>
            </li>
            <li class>
              <a data-toggle="tab" href="#org-employer">
                Employer info
                <i class="fa"></i>
              </a>
            </li>
            <li class>
              <a data-toggle="tab" href="#org-changepassword">
                Change password
                <i class="fa"></i>
              </a>
            </li>
          </ul>
        </aside>
        <!-- /TABS -->
        <!-- FIELDS -->
        <aside class="aside">
          <form id="corporate-edit-form" name="corporate-edit-form" data-validate="parsley">
            <div class="block p-a errorMessage"></div>
            <div class="tab-content panel-body" style="min-height: 450px !important;">
              <!-- Details -->
              <div id="org-details" class="tab-pane active">
                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Name</div>
                  <div class="col-xs-9">
                    <input
                      class="form-control"
                      v-model="profile.name"
                      v-validate="{required:true}"
                      data-vv-name="name"
                    />
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('name')}}</span>
                  </div>
                </div>
                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Trading Name</div>
                  <div class="col-xs-9">
                    <input
                      class="form-control"
                      v-model="profile.trading_name"
                      data-vv-name="name"
                    />
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('trading_name')}}</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Organisation type</div>
                  <div class="col-xs-9">
                    <select
                      class="md-input form-control"
                      v-validate="{required:true}"
                      data-vv-name="type_id"
                      v-model="profile.type_id"
                    >
                      <option value></option>
                      <option v-for="type in orgTypes" :value="type.id" :key="type.id">{{type.name}}</option>
                    </select>
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('type_id')}}</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Industry</div>
                  <div class="col-xs-9">
                    <select
                      class="md-input form-control"
                      v-validate="{required:true}"
                      data-vv-name="industry_id"
                      v-model="profile.industry_id"
                    >
                      <option value></option>
                      <option
                        v-for="industry in industries"
                        :value="industry.id"
                        :key="industry.id"
                      >{{industry.name}}</option>
                    </select>
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('industry_id')}}</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Business services</div>
                  <div class="col-xs-9 m-b-xs business-services-tags">
                    <vue-tags-input
                      v-model="tag"
                      :tags="business_services"
                      :autocomplete-items="autocompleteItems"
                      :allow-edit-tags="true"
                      :placeholder="'choose business services'"
                      @tags-changed="tagChanged"
                    />
                    <span
                      v-if="submitted && !business_services.length"
                      class="help-block m-b-none error-message"
                    >This value is required.</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Registration number</div>
                  <div class="col-xs-9">
                    <input
                      class="form-control"
                      v-model="profile.reg_number"
                      data-vv-name="reg_number"
                      v-validate="{required:true}"
                    />
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('reg_number')}}</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Founded</div>
                  <div class="col-xs-9">
                    <input
                      class="form-control"
                      v-model="profile.founded_year"
                      data-vv-name="founded_year"
                    />
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('founded_year')}}</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Revenues</div>
                  <div class="col-xs-9">
                    <input class="form-control" v-model="profile.revenues" data-vv-name="revenues" />
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('revenues')}}</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Headcount</div>
                  <div class="col-xs-9">
                    <select
                      class="md-input form-control"
                      v-model="profile.no_employee"
                      data-vv-name="no_employee"
                    >
                      <option value="0" selected="selected">number of people</option>
                      <option value="1 - 10">1 - 10</option>
                      <option value="11 - 50">11 - 50</option>
                      <option value="51 - 100">51 - 100</option>
                      <option value="101 - 250">101 - 250</option>
                      <option value="251 - 500">251 - 500</option>
                      <option value="501 - 1,000">501 - 1,000</option>
                      <option value="1,001 - 5,000">1,001 - 5,000</option>
                      <option value="5,001 - 10,000">5,001 - 10,000</option>
                      <option value="10,000+">10,000+</option>
                    </select>
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('no_employee')}}</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Email</div>
                  <div class="col-xs-9">
                    <input
                      class="form-control"
                      v-model="profile.contact_email"
                      v-validate="'email'"
                      data-vv-name="contact_email"
                    />
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('contact_email')}}</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Phone</div>
                  <div class="col-xs-9">
                    <input class="form-control" v-model="profile.phone" data-vv-name="phone" />
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('phone')}}</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Fax</div>
                  <div class="col-xs-9">
                    <input
                      class="form-control"
                      v-model="profile.fax_number"
                      data-vv-name="fax_number"
                    />
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('fax_number')}}</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Contact name</div>
                  <div class="col-xs-9">
                    <input
                      class="form-control"
                      v-model="profile.contact_name"
                      data-vv-name="contact_name"
                    />
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('contact_name')}}</span>
                  </div>
                </div>
                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Contact phone no.</div>
                  <div class="col-xs-9">
                    <input
                      class="form-control"
                      v-model="profile.contact_phone"
                      data-vv-name="contact_phone"
                    />
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('contact_phone')}}</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Website</div>
                  <div class="col-xs-9">
                    <input class="form-control"
                      v-model="profile.website"
                      v-validate="{url: {require_protocol: true }}"
                      data-vv-name="website" />
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('website')}}</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Facebook</div>
                  <div class="col-xs-9">
                    <input
                      @keyup="validationSocial()"
                      class="form-control"
                      v-model="profile.facebook"
                    />
                    <span
                      v-if="submitted && !validFacebook"
                      class="help-block m-b-none error-message"
                    >Facebook url must be entered in full format. Example: https://www.facebook.com/accountname</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">X (Twitter)</div>
                  <div class="col-xs-9">
                    <input
                      @keyup="validationSocial()"
                      class="form-control"
                      v-model="profile.twitter"
                    />
                    <span
                      v-if="submitted && !validTwitter"
                      class="help-block m-b-none error-message"
                    >Twitter url must be entered in full format. Example: https://twitter.com/accountname</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Instagram</div>
                  <div class="col-xs-9">
                    <input
                      @keyup="validationSocial()"
                      class="form-control"
                      v-model="profile.instagram"
                    />
                    <span
                      v-if="submitted && !validInstagram"
                      class="help-block m-b-none error-message"
                    >Instagram url must be entered in full format</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Linkedin</div>
                  <div class="col-xs-9">
                    <input
                      @keyup="validationSocial()"
                      class="form-control"
                      v-model="profile.linkedin"
                    />
                    <span
                      v-if="submitted && !validLinkedIn"
                      class="help-block m-b-none error-message"
                    >Linkedin must be entered in full format. Example: https://www.linkedin.com/in/accountname/</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Address</div>
                  <div class="col-xs-9">
                    <input class="form-control" v-model="profile.address" data-vv-name="address" />
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('address')}}</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Address 2</div>
                  <div class="col-xs-9">
                    <input
                      class="form-control"
                      v-model="profile.address_2"
                      data-vv-name="address_2"
                    />
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('address_2')}}</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">City</div>
                  <div class="col-xs-9">
                    <input class="form-control" v-model="profile.city" data-vv-name="city" />
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('city')}}</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Postcode</div>
                  <div class="col-xs-9">
                    <input class="form-control" v-model="profile.postcode" data-vv-name="postcode" />
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('postcode')}}</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">State</div>
                  <div class="col-xs-9">
                    <input class="form-control" v-model="profile.state" data-vv-name="state" />
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('state')}}</span>
                  </div>
                </div>

                <div class="row form-group m-b-sm">
                  <div class="col-xs-3 text-muted">Country</div>
                  <div class="col-xs-9">
                    <select
                      class="select2"
                      v-model="profile.country_id"
                      v-validate="{required:true}"
                      data-vv-name="country_id"
                    >
                      <option value></option>
                      <option
                        v-for="country in countries"
                        :value="country.id"
                        :key="country.id"
                      >{{country.name}}</option>
                    </select>
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('country_id')}}</span>
                  </div>
                </div>

                <div class="row form-group m-b-xs">
                  <div class="col-xs-3 text-muted">Map</div>
                  <div class="col-xs-9" style>
                    <input class type="hidden" />
                    <google-map
                      :inputSearch="true"
                      :changeMarker="true"
                      :location="profile.geolocation"
                      @get-marker="setLocation"
                    ></google-map>
                  </div>
                </div>

                <div class="row form-group m-b-xs">
                  <div class="col-xs-3 text-muted">Description</div>
                  <div class="col-xs-9">
                    <textarea class="form-control" rows="8"
                      v-model="profile.about"
                      data-vv-name="about"></textarea>
                    <span
                      class="help-block m-b-none error-message"
                    >{{this.$validator.errors.first('about')}}</span>
                  </div>
                </div>

                <div class="row form-group m-b-xs">
                  <div class="col-sm-3">
                    <span class="block text-muted">Business hours</span>
                  </div>
                  <div class="col-xs-9">
                    <business-hours ref="businessHours" :data="business_hours"></business-hours>
                  </div>
                </div>

                <div class="row form-group m-b-xs">
                  <div class="col-xs-3 text-muted">Awards</div>
                  <div class="col-xs-9">
                    <div @click="addAward" class="clearfix">
                      <span id="add-award" class="pull-right btn btn-sm btn-light">
                        <i class="fa fa-plus"></i>add award
                      </span>
                    </div>
                    <award
                      class="m-t-lg"
                      v-for="(award,index) of awards"
                      :index="index"
                      :data.sync="award"
                      :key="index"
                      v-on:remove-award="removeAward"
                      v-on:updateAward="updateAwards($event,index)"
                    ></award>
                  </div>
                </div>

                <div class="row form-group m-b-xs">
                  <div class="col-xs-3 text-muted">Affiliations</div>
                  <div class="col-xs-9">
                    <div @click="addAffilition" class="clearfix">
                      <span id="add-affiliation" class="pull-right btn btn-sm btn-light">
                        <i class="fa fa-plus"></i> add affiliation
                      </span>
                    </div>
                    <affiliation
                      class="m-t-lg"
                      v-for="(affiliation,index) of affiliations"
                      :index="index"
                      :data.sync="affiliation"
                      :key="index"
                      v-on:remove-affiliation="removeAffiliation"
                      v-on:updateAffiliation="updateAffiliations($event,index)"
                    ></affiliation>
                    <span class="help-block m-b-none"></span>
                  </div>
                </div>
              </div>

              <!-- History & milestone -->
              <div id="org-history" class="tab-pane">
                <div class="row form-group m-b-xs">
                  <div class="col-xs-12">
                    <vue-editor
                      id="history-and-milestones"
                      v-model="profile.history_and_milestones"
                      :editorToolbar="customToolbar"
                    ></vue-editor>
                    <span class="help-block m-b-none"></span>
                  </div>
                </div>
              </div>

              <!-- Product & services -->
              <div id="org-productsandservices" class="tab-pane">
                <div class="row form-group m-b-xs">
                  <div class="col-xs-12">
                    <vue-editor
                      id="products_and_services"
                      v-model="profile.products_and_services"
                      :editorToolbar="customToolbar"
                    ></vue-editor>
                    <span class="help-block m-b-none"></span>
                  </div>
                </div>
              </div>

              <!--Employer -->
              <div id="org-employer" class="tab-pane">
                <div class="row form-group m-b-xs">
                  <div class="col-xs-3 text-muted">Why join us</div>
                  <div class="col-xs-9">
                    <textarea v-model="profile.employer_why_join_us" class="form-control" rows="6"></textarea>
                    <span class="help-block m-b-none"></span>
                  </div>
                </div>
                <div class="row form-group m-b-xs">
                  <div class="col-xs-3 text-muted">Our work values</div>
                  <div class="col-xs-9">
                    <textarea v-model="profile.employer_values" class="form-control" rows="6"></textarea>
                    <span class="help-block m-b-none"></span>
                  </div>
                </div>
                <div class="row form-group m-b-xs">
                  <div class="col-xs-3 text-muted">Our work environment</div>
                  <div class="col-xs-9">
                    <textarea v-model="profile.employer_environment" class="form-control" rows="6"></textarea>
                    <span class="help-block m-b-none"></span>
                  </div>
                </div>
                <div class="row form-group m-b-xs">
                  <div class="col-xs-3 text-muted">Benefits</div>
                  <div class="col-xs-9">
                    <input v-model="profile.employer_benefits" class="form-control" />
                    <span class="help-block m-b-none"></span>
                  </div>
                </div>
                <div class="row form-group m-b-xs">
                  <div class="col-xs-3 text-muted">Dress code</div>
                  <div class="col-xs-9">
                    <input v-model="profile.employer_dress_code" class="form-control" />
                    <span class="help-block m-b-none"></span>
                  </div>
                </div>
              </div>

              <!--Change password -->
              <change-password id="org-changepassword"></change-password>
            </div>
          </form>
        </aside>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import affiliation from '../../components/form-components/affiliation'
import award from '../../components/form-components/award'
import businessHours from '../../components/form-components/business-hours'
import GoogleMap from '../../components/about/google-map'
import { VueEditor } from 'vue2-editor'
import VueTagsInput from '@johmun/vue-tags-input'
import AvatarCropper from '../../components/form-components/avatar-cropper'
import CropImageCropper from '../../components/form-components/cover-image-cropper'
import ChangePassword from '../../../account_settings/change-password/change-password'
import ApiService from '../../../../services/ApiService'
import ValidatorDictinary from '../../../../locales/validator/dictionary'

export default {
  components: {
    ChangePassword,
    affiliation,
    award,
    businessHours,
    GoogleMap,
    VueEditor,
    VueTagsInput,
    AvatarCropper,
    CropImageCropper,
  },
  watch: {
    tag: function (tag) {
      this.autocompleteItems = this.tags.filter((i) => {
        return i.text.toLowerCase().startsWith(tag.toLowerCase())
      })
      this.autocompleteItems.unshift({
        text: tag + '*',
      })
      setTimeout(function () {
        let childs,
          parent,
          div = document.getElementsByClassName('ti-autocomplete')
        if (div && div.length > 0) parent = div[0].getElementsByTagName('ul')
        if (parent && parent.length > 0) childs = parent[0].getElementsByTagName('li')
        if (childs && childs.length > 0)
          childs[0].className = childs[0].className + ' ti-selected-item'
      }, 100)
    },
  },
  data() {
    return {
      isImageUrl: false,
      isCoverImageUrl: false,
      validFacebook: false,
      validTwitter: false,
      validLinkedIn: false,
      validInstagram: false,
      accountService: new ApiService(
        process.env.ACCOUNT_URL,
        window.user.oauth_token
      ),
      customToolbar: [
        ['code-block'],
        ['bold'],
        ['italic'],
        ['strike'],
        ['underline'],
        [{ list: 'ordered' }],
        [{ list: 'bullet' }],
        [{ indent: '+1' }, { indent: '-1' }],
        ['link'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' },
        ],
        [{ header: false }],
      ],
      profile: {
        type: 2, // CORPORATE type id,
        name: '',
        trading_name: '',
        reg_number: '',
        industry_id: '',
        type_id: '',
        sector_id: '',
        reg_date: '',
        about: '',
        phone: '',
        mobile: '',
        address: '',
        address_2: '',
        country_id: '',
        city: '',
        state: '',
        postcode: '',
        contact_name: '',
        contact_phone: '',
        fax_number: '',
        contact_email: '',
        website: '',
        founded_year: '',
        no_employee: '',
        revenues: '',
        facebook: '',
        twitter: '',
        linkedin: '',
        instagram: '',
        geolocation: {},
        employer_why_join_us: '',
        employer_values: '',
        employer_environment: '',
        employer_benefits: '',
        employer_dress_code: '',
        products_and_services: '',
        history_and_milestones: '',
      },
      affiliations: [],
      awards: [],
      business_hours: null,

      logoFile: null,
      submitted: false,

      tags: [],
      autocompleteItems: [],
      business_services: [],
      industries: null,
      orgTypes: null,
      sectors: null,
      countries: null,
      tag: '',
      uploadUrl: null,
      uploadCoverImageUrl: null,
      headersUrl: null,
      errorCurrentPassword: false,
      errorNewPassword: false,
      errorConfirmation: false,
    }
  },

  created() {
    this.fetchBusinessServices()
    this.fetchIndustries()
    this.fetchOrgTypes()
    this.fetchSectors()
    this.fetchCountries()
    this.validationSocial()

    this.uploadUrl = `${process.env.ACCOUNT_URL}/api/profiles/${this.$route.params.id}/image`
    this.uploadCoverImageUrl = `${process.env.ACCOUNT_URL}/api/profiles/${this.$route.params.id}/coverImage`
    this.headersUrl = { Authorization: `Bearer ${window.user.oauth_token}` }

    this.$validator.localize(ValidatorDictinary)
  },

  mounted() {
    let _this = this
    $('.select2')
      .select2({ width: '100%' })
      .on('change', function () {
        _this.profile.country_id = this.value
      })
  },

  computed: {
    ...mapGetters(['getCountryName', 'getIndustryName']),
  },

  methods: {
    setLocation(marker) {
      this.profile.geolocation = marker.marker
    },

    addAffilition() {
      this.affiliations.unshift({
        organization: '',
        start_date: '',
        end_date: '',
      })
      this.refreshParsleyForm()
    },

    addAward() {
      this.awards.unshift({
        name: '',
        organization: '',
        date: '',
        description: '',
      })
      this.refreshParsleyForm()
    },

    removeAffiliation(removeIndex) {
      this.affiliations = this.affiliations.filter(
        (val, index) => index !== removeIndex
      )
      this.refreshParsleyForm()
    },

    removeAward(removeIndex) {
      this.awards = this.awards.filter((val, index) => index !== removeIndex)
      this.refreshParsleyForm()
    },

    fetchBusinessServices() {
      this.accountService.get(`/api/business-services`).then((res) => {
        this.tags = res.data.map((a) => {
          return { text: a.name, id: a.id, tiClasses: ['ti-valid'] }
        })
        this.autocompleteItems = this.tags
        this.getEditProfileData()
      })
    },

    tagChanged(newTags) {
      this.business_services = newTags
    },

    fetchIndustries() {
      this.accountService
        .get(`/api/industries`)
        .then((res) => (this.industries = res.data))
    },

    fetchOrgTypes() {
      this.accountService
        .get(`/api/corporate-types`)
        .then((res) => (this.orgTypes = res.data))
    },

    fetchSectors() {
      this.accountService
        .get(`/api/sectors`)
        .then((res) => (this.sectors = res.data))
    },

    fetchCountries() {
      this.accountService.get(`/api/countries`).then((res) => {
        this.countries = res.data
        this.$store.dispatch('setCountries', res.data)
      })
    },

    handleCancel(e) {
      this.$router.push(`/view/${this.$route.params.id}`)
    },

    validationSocial() {
      this.validFacebook = this.isUrlValid(this.profile.facebook, 'facebook')
      this.validTwitter = this.isUrlValid(this.profile.twitter, 'twitter')
      this.validLinkedIn = this.isUrlValid(this.profile.linkedin, 'linkedin')
      this.validInstagram = this.isUrlValid(this.profile.instagram)
    },

    handleSubmit(e) {
      this.submitted = true
      this.validationSocial()
      this.getBusinessHours()
      this.getAwards()
      this.getAffiliations()
      // we are using jquery validator for affialations, awards, business hours
      if (!$('#corporate-edit-form').parsley('validate')) {
        this.jumpToFirstError()
        return
      }
      // custom validations
      if (!(
        this.validFacebook &&
        this.validTwitter &&
        this.validLinkedIn &&
        this.validInstagram &&
        this.business_services.length
      )){
        this.jumpToFirstError()
        return
      }
      this.$validator.validate().then((valid) => {
        if(valid){
          this.accountService
            .patch(
              `/api/profiles/${this.$route.params.id}`,
              this.preparingBody()
            )
            .then((res) => {
              this.$toaster.success(
                'Profile information has been updated successfully'
              )
              setTimeout(() => {
                this.$router.push(`../view/${this.$route.params.id}`)
                this.$router.go()
              }, 1000)
            })
            .catch((error) => {
              let status = error.response.status
              let errorData =
                'undefined' !== typeof error.response.data
                  ? error.response.data
                  : null
              if (status === 422) {
                this.addErrors(errorData.errors)
                this.jumpToFirstError()
              } else {
                console.log(errorData)
              }
          })
        }else{
          this.jumpToFirstError()
        }
      })
    },

    preparingBody() {
      let body = this.profile
      body.awards = this.awards
      body.affiliation = this.affiliations
      body.social_accounts = []
      if (this.profile.facebook) {
        body.social_accounts.push({
          service: 'facebook',
          account: '',
          link: this.profile.facebook,
        })
      }
      if (this.profile.twitter) {
        body.social_accounts.push({
          service: 'twitter',
          account: '',
          link: this.profile.twitter,
        })
      }
      if (this.profile.linkedin) {
        body.social_accounts.push({
          service: 'linkedin',
          account: '',
          link: this.profile.linkedin,
        })
      }
      if (this.profile.instagram) {
        body.social_accounts.push({
          service: 'instagram',
          account: '',
          link: this.profile.instagram,
        })
      }

      let bs = {}
      this.business_services.map((tag, i) => {
        if (Number.isInteger(tag.id)) {
          bs[i] = tag.id
        } else {
          // for new tags
          bs[i] = {
            text: this.business_services[i].text.replace(/\*\s*$/, '')
          }
        }
      })
      body.business_services = bs

      body.business_hours = []
      this.business_hours.forEach((hour, index) => {
        body.business_hours[index] = {
          day: hour.day,
          start: hour.start,
          end: hour.end,
        }
      })
      return body
    },


    isUrlValid(website, type = null) {
      if (!website) return true
      if (type === 'facebook') {
        return website.match(
          /^http(s)?:\/\/?(www\.)?facebook.com\/[a-zA-Z0-9(\.\?)?]/
        ) == null
          ? false
          : true
      } else if (type === 'twitter') {
        return website.match(
          /^http(s)?:\/\/?(www\.)?twitter.com\/[a-zA-Z0-9(\.\?)?]/
        ) == null
          ? false
          : true
      } else if (type === 'linkedin') {
        return website.match(
          /^http(s)?:\/\/?(www\.)?linkedin.com\/in\/[a-zA-Z0-9(\.\?)?]/
        ) == null
          ? false
          : true
      }
      return website.match(
        /^http(s)?:\/\/.?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      ) === null
        ? false
        : true
    },

    handleCoverImageCompleted(data) {
      this.profile.cover_image = data.data.cover_image
      this.fillCoverImage(this.profile.cover_image)
    },

    handleCompleted(data) {
      this.profile.public_picture = data.data.public_picture
      this.fillImage(this.profile.public_picture)
    },

    handlerError(err) {
      console.log(err)
    },

    uploadImage(event) {
      let reader = new FileReader()
      this.logoFile = event.srcElement.files[0]

      reader.readAsDataURL(this.logoFile)
      reader.onload = (e) => {
        this.fillImage(e.target.result)
      }
    },

    addErrors(errors) {
      errors.forEach((error) => {
        this.$validator.errors.add({
          field: error.field,
          msg: error.message,
        })
      })
    },

    jumpToFirstError(){
      let elements = document.body.getElementsByClassName('error-message');
      for (let i = 0; i < elements.length; i++) {
        if(elements[i].innerHTML != ""){
          elements[i].scrollIntoView({ behavior: 'instant', block: 'center' })
          break
        }
      }
    },

    updateAffiliations(event, index) {
      this.affiliations[index] = JSON.parse(JSON.stringify(event))
    },

    updateAwards(event, index) {
      this.awards[index] = JSON.parse(JSON.stringify(event))
    },

    getBusinessHours() {
      this.business_hours = this.$refs.businessHours.getActiveDays()
    },

    getAffiliations() {
      this.profile.affiliations = this.affiliations
    },

    getAwards() {
      this.profile.awards = this.awards
    },

    getEditProfileData() {
      this.accountService
        .get(`/api/profiles/${this.$route.params.id}`)
        .then((res) => {
          this.profile = res.data.corporateProfile
          this.profile.social_accounts.map((account) => {
            switch (account.service) {
              case 'facebook':
                this.profile.facebook = account.link
                break
              case 'twitter':
                this.profile.twitter = account.link
                break
              case 'linkedin':
                this.profile.linkedin = account.link
                break
              case 'instagram':
                this.profile.instagram = account.link
                break
            }
          })
          this.logoFile = res.data.public_picture
          this.fillImage(res.data.public_picture)
          this.fillCoverImage(res.data.cover_image)
          this.profile.phone = res.data.phone
          this.profile.mobile = res.data.mobile
          this.profile.address = res.data.address
          this.profile.address_2 = res.data.address_2
          this.profile.city = res.data.city
          this.profile.postcode = res.data.postcode
          this.profile.state = res.data.state
          this.profile.country_id = res.data.country_id
          this.profile.about = res.data.about
          this.profile.geolocation = res.data.geolocation
          this.profile.public_picture = res.data.public_picture
          this.defineBusinessServices(
            res.data.corporateProfile.business_services
          )

          this.business_hours = res.data.corporateProfile.business_hours
            ? res.data.corporateProfile.business_hours
            : []
          this.awards = res.data.corporateProfile.awards
            ? res.data.corporateProfile.awards
            : []
          this.affiliations = res.data.corporateProfile.affiliation
            ? res.data.corporateProfile.affiliation
            : []
          this.setCountryForSelect2()
        })
    },

    setCountryForSelect2() {
      $('.select2').val(this.profile.country_id).trigger('change')
    },

    defineBusinessServices(tagIds) {
      if (tagIds) {
        tagIds.map((tag, i) => {
          if (this.autocompleteItems.length) {
            this.autocompleteItems.map((tg, j) => {
              if (tag === tg.id) {
                this.business_services.push({ id: tag, text: tg.text })
              }
            })
          }
        })
      }
    },

    fillImage(imageUrl) {
      this.$refs.logoBox.style =
        'background: url(' +
        imageUrl +
        ') no-repeat;background-size: cover;z-index: 999;width: 125px;height: 125px;cursor:pointer;'

      var image = new Image()
      image.src = imageUrl
      let that = this
      image.onload = function () {
        that.isImageUrl = true
      }
    },

    fillCoverImage(imageUrl) {
      imageUrl = imageUrl
        ? imageUrl
        : 'https://ukuyadev.s3.amazonaws.com/system/cover_default.jpg'
      this.$refs.coverImageBox.style =
        'background: url(' +
        imageUrl +
        ') no-repeat;background-size: cover;z-index: 999;cursor:pointer;'
      var image = new Image()
      image.src = imageUrl
      let that = this
      image.onload = function () {
        that.isCoverImageUrl = true
      }
    },

    refreshParsleyForm() {
      $('.error-message').remove()
      $('#corporate-edit-form').parsley().destroy()
      $('#corporate-edit-form').parsley()
    },
  },
}
</script>

<style scoped>
.preloader {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.loaderPosition {
  position: relative;
}
.error-message {
  margin: 0;
  padding: 0;
  list-style: none;
  margin-top: 6px;
  font-size: 12px;
  color: #f44455;
}
</style>

<style lang="scss">
.vue-tags-input {
  max-width: 100% !important;
}

.ti-tag {
  color: #555 !important;
  border: 1px solid #cbd5dd;
  background-color: white !important;
  font-size: 14px !important;
  flex-direction: row-reverse;
  .ti-actions {
    margin-left: 0px !important;
    margin-right: 2px;
    font-size: 1em !important;
    .ti-icon-close {
      font-weight: 900 !important;
    }
  }
}

.ti-autocomplete {
  .ti-selected-item {
    background-color: #337ab7;
    color: white;
    text-decoration-line: underline;
  }
}

.vue-tags-input .ti-deletion-mark {
  color: #555 !important;
  background-color: #999 !important;
  font-size: 14px;
}
.business-services-tags .vue-tags-input .ti-input {
  border: none;
}
.line-height-39 {
  height: 39px;
}
</style>
